import React, { useRef, useState, useEffect } from "react";
import styled, { css } from "styled-components";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import "./home.css";
import Contact from "../../Dependence/Contact/Contact.js";
import HeaderNav from "../../HeaderFotter/Header/Header.js";
import Fotter from "../../HeaderFotter/Fotter/Fotter.js";
import BlurryCursor from "../../Dependence/Cursor/cursor.jsx";
import FixedNav from "../../HeaderFotter/FixedNav/Fixednav.js";
import { effect_gsap, effect_out } from "../../../gsapHelper/effectGsap";

import OurActivities from "../OurActivities/OurActivities.js";

const sizes = {
  desktop: 1024,
  tablet: 768,
  phone: 576,
};

const media = Object.keys(sizes).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${sizes[label] / 16}em) {
      ${css(...args)}
    }
  `;
  return acc;
}, {});

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  line-height: 1.5;
  font-size: 20px;
  font-weight: 300;
  color: #111;
`;

const Section = styled.section`
  padding: 0 50px;
  padding-bottom: 150px;
  max-width: 1330px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  /* Đảm bảo padding không thay đổi kích thước của div */
  box-sizing: border-box;

  ${media.desktop`
    padding: 50px 30px; // ví dụ thay đổi padding trên desktop nhỏ
  `}
  ${media.tablet`
    padding: 20px 20px; // thay đổi padding trên tablet
  `}
  ${media.phone`
    padding: 10px 10px; // thay đổi padding trên điện thoại
    padding-bottom: 100px; // giảm padding bottom trên điện thoại
  `}
`;

const Home = () => {
  const [isActive, setIsActive] = useState(false);
  gsap.registerPlugin(useGSAP);
  const content = useRef();

  gsap.registerPlugin(ScrollTrigger);

  useEffect(() => {
    // Chắc chắn rằng window và document đều sẵn sàng
    if (typeof window !== "undefined" && typeof document !== "undefined") {
      ScrollTrigger.refresh();
    }
  }, []);

  useEffect(() => {
    const imagesLoaded = document.querySelectorAll("img");
    const totalImages = imagesLoaded.length;
    let imagesLoadedCount = 0;

    imagesLoaded.forEach((image) => {
      if (image.complete) {
        imagesLoadedCount++;
      } else {
        image.onload = () => {
          imagesLoadedCount++;
          if (imagesLoadedCount === totalImages) {
            // Khởi tạo ScrollTrigger sau khi tất cả hình ảnh đã tải xong
            ScrollTrigger.refresh();
          }
        };
      }
    });

    if (imagesLoadedCount === totalImages) {
      ScrollTrigger.refresh();
    }
  }, []);

  useGSAP(
    () => {
      const check_mobile = matchMedia("(max-width: 768px)").matches;

      // Cái này của phần loading_page
      gsap.fromTo(
        ".ab",
        { width: "1%", opacity: 0 },
        {
          width: "50%",
          opacity: 1,
          duration: 3,
          ease: "power3.out",
        }
      );

      gsap.fromTo(
        ".loading-page",
        { opacity: 1 },
        {
          opacity: 0,
          display: "none",
          duration: 1.5,
          delay: 4,
        }
      );

      gsap.fromTo(
        ".name-container",
        {
          y: 50,
          autoAlpha: 0,
        },
        {
          y: 0,
          autoAlpha: 1,
          duration: 2,
          delay: 0.5,
        }
      );

      // Hiệu ứng bên AboutUs Home
      // Hiệu ứng lơ lửng
      const tl = gsap.timeline({ repeat: -1, yoyo: true });
      tl.to(".ao-thun", { y: -25, duration: 1.5, ease: "power1.inOut" }).to(
        ".ao-thun",
        { y: 0, duration: 1.5, ease: "power1.inOut" }
      );

      if (check_mobile) {
        // Thực hiện các hiệu ứng dành cho thiết bị di động
        gsap.fromTo(
          ".bg-hong",
          {
            opacity: 0,
            y: -200,
          },
          {
            opacity: 1,
            y: "200px",
            ease: "power1.inOut",
            scrollTrigger: {
              trigger: ".bg-hong",
              start: "center center",
              end: "bottom top",
              toggleActions: "play none none reverse",
              scrub: 4,
              duration: 2,
            },
          }
        );
      } else {
        // Thực hiện các hiệu ứng dành cho desktop

        gsap.fromTo(
          ".bg-hong",
          {
            opacity: 0,
            y: -200,
          },
          {
            opacity: 1,
            y: "200px",
            ease: "power1.inOut",
            scrollTrigger: {
              trigger: ".bg-hong",
              start: "top 85%",
              end: "bottom top",
              toggleActions: "play none none reverse",
              scrub: 4,
              duration: 2,
            },
          }
        );
      }
      // Tạo animation
      effect_gsap(".Introduction", 0, check_mobile);

      effect_gsap(".our-mission", 0, check_mobile);
      effect_out(".our-mission", -100, check_mobile);

      effect_gsap(".custom-pod", 0, check_mobile);
      effect_out(".custom-pod", -100, check_mobile);

      effect_gsap(".custom-pod-2", 0, check_mobile);
      effect_out(".custom-pod-2", -100, check_mobile);

      effect_out(".years", -100, check_mobile);

      effect_gsap(".our-products", 0, check_mobile);
      effect_out(".our-products", -100, check_mobile);

      effect_gsap(".our-teams", 0, check_mobile);
      effect_out(".our-teams", -100, check_mobile);

      effect_gsap(".contact-sc", 0, check_mobile); // Class này ở trong Section con của Contact
    },
    { scope: content }
  );

  // Hàm để truyền xuống prop cho component con, component con có thể tự cập nhật lại vào đây.
  // const handleActivation = (active) => {
  //   setIsActive(active);
  // };

  return (
    <Container className="content" ref={content}>
      
      <HeaderNav></HeaderNav>

      <Section className="ct-section" style={{ opacity: "1", filter: "none" }}>
        <div className="ct-main">
          <div className="ct-div-black hidden md:block w-[38%]"></div>
          <div className="ct-div-block">
            <div className="ct-div-block relative">
              <div
                className=" effect1 ct-text-block blend subheading fade z-10"
                style={{ transform: "translate(0px, 0px)", opacity: "1" }}
              >
                WELCOME
              </div>
              <h1
                onMouseOver={() => {
                  setIsActive(true);
                }}
                onMouseLeave={() => {
                  setIsActive(false);
                }}
                id="headline-4-9"
                className="ct-headline heading-main z-10"
              >
                VISGROUP
              </h1>

              <div className="ct-div-black md:opacity-0 w-[100%]"></div>
            </div>
            {/* Thanh den */}
            <div
              id="thanh_trang"
              className="ab opacity-0 mt-10"
              style={{ width: "1%", marginBottom: "10px" }}
            ></div>

            <div id="main-content" className="effect2 md:w-[53%]">
              <div style={{ transform: "translate(0px, 0px)", opacity: "1" }}>
                <p>
                  Welcome to VIS Group, where creativity and technology merge to
                  create leading e-commerce solutions. Established in 2015, we
                  are proud to be one of the E-commerce companies growing
                  rapidly and sustainably in the European - American market. At
                  VIS Group, each member has the opportunity to contribute to
                  the common success and enjoy the fruits of their labor through
                  a fair and transparent distribution policy. With a team of
                  experts with extensive experience in developing online
                  products and implementing marketing campaigns since 2015, we
                  are confident in bringing customers the best products and
                  services. We constantly improve and innovate to match market
                  trends, while ensuring a dynamic, creative and friendly
                  working environment where everyone can develop both
                  professionally and personally. core. At VIS Group, we put
                  human values ​​first. We believe that each employee is not
                  only a part of the company but also an important member in
                  building and developing corporate culture. Therefore, we are
                  committed to ensuring a rich material and spiritual life for
                  each individual. Join us in creating true values ​​and
                  achieving professional goals, contributing to the overall
                  success of VIS Group and yourself.
                </p>
              </div>
              <div id="ct-main-icon">
                <img
                  alt=""
                  src="/Img/icon/amazon.png"
                  className="ct-image fade entered lazyloaded"
                  style={{ transform: "translate(0px, 0px)", opacity: "1" }}
                />
                <img
                  alt=""
                  src="/Img/icon/tiktok.png"
                  className="ct-image fade entered lazyloaded"
                  style={{ transform: "translate(0px, 0px)", opacity: "1" }}
                />
                <img
                  alt=""
                  src="/Img/icon/etsy.jfif"
                  className="ct-image fade entered lazyloaded"
                  style={{ transform: "translate(0px, 0px)", opacity: "1" }}
                />
                <img
                  alt=""
                  src="https://www.pinguinweb.de/wp-content/uploads/2022/09/woocommerce.png"
                  className="ct-image fade entered lazyloaded"
                  style={{ transform: "translate(0px, 0px)", opacity: "1" }}
                />
                <img
                  alt=""
                  src="https://www.pinguinweb.de/wp-content/uploads/2022/09/oxy.png"
                  className="ct-image fade entered lazyloaded"
                  style={{ transform: "translate(0px, 0px)", opacity: "1" }}
                />
              </div>
            </div>
          </div>
        </div>
      </Section>
      <Section>
        <div className="slider-container">
          <div className="slider">
            <img
              src="/Img/head-logo1.png"
              style={{ height: "50px", width: "auto" }}
              alt="Loews Hotels"
            />
            <img
              src="/Img/tiktok.png"
              style={{ height: "50px", width: "auto" }}
              alt="Trader Joe's"
            />
            <img
              src="/Img/HUSTLE1.png"
              style={{ height: "50px", width: "auto" }}
              alt="Hyatt"
            />
            <img
              src="/Img/VISACE1.png"
              style={{ height: "50px", width: "auto" }}
              alt="Marriott Hotels & Resorts"
            />
            {/* lặp lại để tạo hiệu ứng liên tục */}
            <img
              src="/Img/head-logo1.png"
              style={{ height: "50px", width: "auto" }}
              alt="Loews Hotels"
            />
            <img
              src="/Img/tiktok.png"
              style={{ height: "50px", width: "auto" }}
              alt="Trader Joe's"
            />
            <img
              src="/Img/HUSTLE1.png"
              style={{ height: "50px", width: "auto" }}
              alt="Hyatt"
            />
            <img
              src="/Img/VISACE1.png"
              style={{ height: "50px", width: "auto" }}
              alt="Marriott Hotels & Resorts"
            />
          </div>
        </div>
      </Section>

      {/* About Us */}
      {/* <AboutUs onActive={handleActivation}></AboutUs> */}

      {/* About */}
      <Section className="Introduction opacity-0">
        <div className="md:flex p-10 rounded-xl">
          <div className="flex flex-col md:w-4/12 pb-5 md:gap-10">
            <div className="uppercase text-clamp-50 font-bold">
              Introduction:
            </div>
            <div id="thanh_den" style={{ width: "100%" }}>
              {" "}
            </div>
            <div>
              Welcome to Vis Group, where innovation in design meets excellence
              in production. Established in 2015 and located in DANANG City, our
              company excels in providing bespoke print on demand (POD)
              solutions in the realm of e-commerce. We pride ourselves on
              transforming creative ideas into tangible products that resonate
              with consumers globally.
            </div>
          </div>
          <div className="flex justify-end">
            <img
              src="/Img/HomePage/firts_vis.jpg"
              alt=""
              className="md:w-11/12 w-full rounded-3xl"
              style={{
                boxShadow:
                  "13px 10px 9px #16231bba, -10px -10px 20px 7px #0c1f0c7a, 13px -2px 20px 11px rgb(0 0 0 / 0.25)",
              }}
            ></img>
          </div>
        </div>
      </Section>

      <Section className="our-mission opacity-0">
        <div
          className="md:flex bg-black p-10 text-white rounded-xl"
          style={{
            boxShadow:
              "-6px 8px 5px 0 rgb(249 217 217), -2px 5px 5px 0 rgba(0, 0, 0, .75), 13px -7px 10px 0 rgba(0, 0, 0, .75), 10px 20px 15px 0 rgba(0, 0, 0, .6), -20px 20px 20px 0 rgba(0, 0, 0, .6), -30px 30px 30px 0 rgba(0, 0, 0, .6), -40px 40px 40px 0 rgba(0, 0, 0, .35)",
          }}
        >
          <div className="hidden md:block">
            <img
              src="/Img/HomePage/2_vis.jpg"
              alt=""
              className="w-11/12 rounded-3xl"
              style={{
                boxShadow:
                  "13px 10px 9px #16231bba, -10px -10px 20px 7px #0c1f0c7a, 13px -2px 20px 11px rgb(0 0 0 / 0.25)",
              }}
            ></img>
          </div>
          <div className="flex flex-col md:w-5/12 pb-5 md:gap-5">
            <div className="uppercase text-[50px] font-bold">Our Mission</div>
            <div id="thanh_trang" style={{ width: "100%" }}>
              {" "}
            </div>
            <div>
              Our mission is to deliver uniquely designed products that cater to
              the individual styles and preferences of our customers. Through
              our cutting-edge POD technology, we ensure that each product not
              only meets but exceeds the expectations of quality, creativity,
              and sustainability.
            </div>
          </div>
          <div className="md:hidden">
            <img
              src="/Img/HomePage/2_vis.jpg"
              alt=""
              className="md:w-11/12 w-full rounded-3xl"
              style={{
                boxShadow:
                  "13px 10px 9px #16231bba, -10px -10px 20px 7px #0c1f0c7a, 13px -2px 20px 11px rgb(0 0 0 / 0.25)",
              }}
            ></img>
          </div>
        </div>
      </Section>

      <Section className="years">
        <div className="relative flex flex-col items-center">
          {/* <img src='/Img/SON_1956.png' alt='' className='z-[1]' ></img> */}
          <img
            src="/Img/HomePage/pod-tshirts.png"
            alt=""
            className="z-[1] w-6/12 ao-thun"
          ></img>
          <div id="thanh_den" style={{ width: "100%" }} className="z-[1]">
            {" "}
          </div>
          <div className="absolute z-0 top-0 md:top-[15%] ml-[-7%] bg-[#dd8e8e] w-[85%] md:w-[45%] h-[75%] md:h-[60%] bg-hong"></div>

          <div
            className="absolute right-[10%] md:right-[16%] top-[15%]"
            style={{ transform: "rotate(-10deg)" }}
          >
            {/* <div>Founder:</div> */}
            <div className='font-["Timberline"] text-[30px] md:text-[50px]'>
              Vis Bui
            </div>
          </div>
          <div className="flex justify-center z-[1]">
            <img
              src="/Img/10-years.png"
              alt=""
              className="w-[50%] md:w-[100%]"
            ></img>
          </div>
          <div className="w-9/12 md:w-3/6 z-[1] text-justify mr-5">
            <p className="m-0">
              {" "}
              <strong>Our Vision: </strong>To be the premier provider of custom
              print solutions in the e-commerce sector, continuously enriching
              our customer experience through innovation, customer service, and
              product excellence.
            </p>
            <p></p>
          </div>
        </div>
      </Section>

      <Section className="hidden md:block custom-pod opacity-0">
        <div className="flex gap-10 relative">
          <div className="flex justify-center absolute w-full h-[650px]">
            <div className="text-[210px] uppercase font-bold text-justify w-11/12 leading-[14.5rem]">
              <div>
                <div className="flex justify-center">Cus</div>
                <div className="flex justify-center">tom</div>
                <div className="flex justify-center">POD</div>
              </div>
              {/* Cus tom POD */}
              {/* Personalized Product Development with Comprehensive POD Services */}
            </div>
          </div>
          <div className="text-justify">
            <div
              className="block float-right h-[650px]"
              style={{ width: "calc(55% - 15px)" }}
            ></div>
            Every Print on Demand (POD) company carries its unique identity,
            defined by its culture, demands, history, employees, and clientele.
            At our company, we strive to tailor each product as personally as
            your company's distinct characteristics. We don't believe that
            conforming your products to a generic digital mold is beneficial.
            What would happen if your new product looks great but your staff
            struggle with modifications and creating new designs? What is the
            point of mimicking a competitor's product if your company's culture
            and target customer base differ? Because we aim for your products to
            have enduring relevance, we meticulously develop each design to suit
            each client specifically. What makes your company unique? How does
            your operation function? What happens when customer issues arise?
            What skills will new employees working with the product have? How
            will your processes evolve over the years? Once we grasp these
            elements, we can craft product designs for you. Beyond just visual
            aesthetics, this approach also encompasses the functionality of
            auxiliary aspects, ensuring alignment with your needs, habits, and
            skill levels.
          </div>
          <div className="text-justify">
            <div
              className="block float-left h-[650px]"
              style={{ width: "calc(55% - 15px)" }}
            ></div>
            Your product development takes place in close coordination with you,
            not only in design but also in management and production. As
            experienced professionals, we ensure that product quality and
            characteristics are not lost during design and implementation, and
            can often even be improved. You can rest assured that your product
            will meet the highest specifications over the long term, such as
            good print quality and fast production times. We work with proven
            methods and software from renowned manufacturers, ensuring long-term
            support. Once the product goes live, we are happy to become your
            permanent contact, not only in marketing the product on digital
            advertising channels but also in providing technical services
            comprehensive and suggest developments related to engineering or
            design. We're always ready to update and adapt new elements to the
            user interface, ensuring you can always customize and create your
            own products with great precision.
          </div>
        </div>
      </Section>

      <Section className="md:hidden custom-pod-2 opacity-0">
        <div className="">
          <div className="text-justify">
            Every Print on Demand (POD) company carries its unique identity,
            defined by its culture, demands, history, employees, and clientele.
            At our company, we strive to tailor each product as personally as
            your company's distinct characteristics. We don't believe that
            conforming your products to a generic digital mold is beneficial.
            What would happen if your new product looks great but your staff
            struggle with modifications and creating new designs? What is the
            point of mimicking a competitor's product if your company's culture
            and target customer base differ? Because we aim for your products to
            have enduring relevance, we meticulously develop each design to suit
            each client specifically. What makes your company unique? How does
            your operation function? What happens when customer issues arise?
            What skills will new employees working with the product have? How
            will your processes evolve over the years? Once we grasp these
            elements, we can craft product designs for you. Beyond just visual
            aesthetics, this approach also encompasses the functionality of
            auxiliary aspects, ensuring alignment with your needs, habits, and
            skill levels.
          </div>

          <div className="">
            <div className=" flex justify-center text-[40px] uppercase font-bold text-justify w-full">
              CUSTOM POD
            </div>
          </div>

          <div className="text-justify">
            Your product development takes place in close coordination with you,
            not only in design but also in management and production. As
            experienced professionals, we ensure that product quality and
            characteristics are not lost during design and implementation, and
            can often even be improved. You can rest assured that your product
            will meet the highest specifications over the long term, such as
            good print quality and fast production times. We work with proven
            methods and software from renowned manufacturers, ensuring long-term
            support. Once the product goes live, we are happy to become your
            permanent contact, not only in marketing the product on digital
            advertising channels but also in providing technical services
            comprehensive and suggest developments related to engineering or
            design. We're always ready to update and adapt new elements to the
            user interface, ensuring you can always customize and create your
            own products with great precision.
          </div>
        </div>
      </Section>

      <Section className="our-products opacity-0">
        <div className="">
          <div className="flex justify-center contacts">
            {/* KIỂU CHỮ KHÁC */}
            {/* <h2 className='text-[#948192] w-auto'></h2> */}
            <h1
              onMouseOver={() => {
                setIsActive(true);
              }}
              onMouseLeave={() => {
                setIsActive(false);
              }}
              id="headline-4-9"
              className="uppercase text-clamp m-0 ct-headline "
            >
              Our Products
            </h1>
          </div>
          <div>
            <div id="thanh_den" style={{ width: "100%" }}></div>
          </div>

          <div className="md:flex justify-between gap-5">
            <div className="md:w-3/6">
              <div className="flex justify-center font-bold uppercase">
                Print on Demand Services:
              </div>
              <p>
                At Vis Group, we specialize in on-demand printing that allows
                for high customization and flexibility. Our services include:
                <br />
                <strong className="pl-5">• Apparel:</strong> Custom t-shirts,
                hoodies, and more with unique designs.
                <br />
                <strong className="pl-5">• Accessories:</strong> Personalized
                bags, hats, and other fashion accessories.
                <br />
                <strong className="pl-5">• Home Decor:</strong> Bespoke items
                such as cushions, posters, and wall art that add a personal
                touch to any space.
              </p>
              <div className="flex justify-center">
                <img
                  src="/Img/HomePage/pod2.jfif"
                  alt=""
                  className="md:w-11/12 w-8/12 rounded-3xl"
                  style={{
                    boxShadow:
                      "13px 10px 9px #16231bba, -10px -10px 20px 7px #0c1f0c7a, 13px -2px 20px 11px rgb(0 0 0 / 0.25)",
                  }}
                ></img>
              </div>
            </div>
            <div className="h-auto pt-10">
              <div
                id="thanh_trang"
                style={{ width: "auto", minWidth: "7px", height: "100%" }}
              ></div>
            </div>
            <div className="md:w-3/6">
              <div className="flex justify-center font-bold uppercase">
                Innovative Design Solutions:
              </div>
              <div className="flex justify-center">
                <img
                  src="/Img/HomePage/pod.jfif"
                  alt=""
                  className="mt-10 md:w-11/12 w-8/12 rounded-3xl"
                  style={{
                    boxShadow:
                      "13px 10px 9px #16231bba, -10px -10px 20px 7px #0c1f0c7a, 13px -2px 20px 11px rgb(0 0 0 / 0.25)",
                  }}
                ></img>
              </div>
              <p>
                Our in-house design team is skilled at creating artwork that
                stands out. We bring your ideas to life with vibrant prints and
                meticulous attention to detail, ensuring that every design is a
                masterpiece.
              </p>
            </div>
          </div>
        </div>
      </Section>

      <Section className="our-teams opacity-0">
        <div className="ct-main">
          <div className="ct-div-black"></div>
          <div className="ct-div-block">
            <div className="ct-div-block">
              {/* <div className="ct-text-block blend subheading fade" style={{ transform: "translate(0px, 0px)", opacity: "1" }}>
                                WELCOME
                            </div> */}
              <h1
                onMouseOver={() => {
                  setIsActive(true);
                }}
                onMouseLeave={() => {
                  setIsActive(false);
                }}
                id="headline-4-9"
                className="pt-10 ct-headline heading-main uppercase"
                style={{ color: "#000", fontSize: "clamp(30px, 10vw, 170px)" }}
              >
                Our Teams
              </h1>
              <div id="thanh_den"></div>
              <div className="self-end mr-[2%]">
                Our warriors are always ready to participate in any project with
                your business.
              </div>
            </div>
            <div className="w-full">
              <div style={{ transform: "translate(0px, 0px)", opacity: "1" }}>
                {/* <p>Our warriors are always ready to participate in any project with your business.</p> */}
                <div className="md:flex flex-col justify-center text-center pt-[50px] pb-[50px]">
                  <div className="img-gallery-container md:flex gap-10 pb-10 md:pb-20">
                    <div data-num="2" className="relative md:w-3/6">
                      <div className="relative flex justify-center">
                        <img
                          src="/Img/temple/cat.webp"
                          alt=""
                          className="img-gal md:h-[555px] h-[450px] w-10/12 md:w-11/12"
                        />
                        <div className="float-gallery-content absolute w-9/12 md:w-10/12 z-0 bg-[#fff] p-0 bottom-0 rounded-md flex justify-between opacity-0 hover:opacity-[1]">
                          <div className="content uk-text-left">
                            <span className="highlight uk-block p-3">
                              <div className="px-5">
                                <p>
                                  <strong>Designer: </strong>
                                </p>{" "}
                                Design printed products such as t-shirts, mugs,
                                bags, etc. Ensure the design matches customer
                                requirements and market trends.
                              </div>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="absolute z-[2] flex justify-center w-full top-0 h-full items-center">
                        <div className="position-main bg-[#fff] px-10 py-5 rounded-2xl opacity-50">
                          {" "}
                          Designer
                        </div>
                      </div>
                    </div>
                    <div data-num="1" className="relative pt-10 md:w-3/6">
                      <div className="relative flex justify-center">
                        <img
                          src="/Img/temple/rabit.webp"
                          alt=""
                          className="img-gal md:h-[555px] h-[450px] w-10/12 md:w-11/12"
                        />
                        <div className="float-gallery-content absolute w-9/12 md:w-10/12 z-0 bg-[#fff] p-0 bottom-0 rounded-md flex justify-between opacity-0 hover:opacity-[1]">
                          <div className="content uk-text-left">
                            <span className="highlight uk-block p-3">
                              <div className="px-5">
                                <p>
                                  <strong>Web Developer</strong>
                                </p>
                                - Build and maintain the company's e-commerce
                                website.
                                <br />- Integrate tools and software to support
                                sales and printing processes.
                              </div>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="absolute z-[2] flex justify-center w-full top-0 h-full items-center">
                        <div className="position-main bg-[#fff] px-10 py-5 rounded-2xl opacity-50">
                          {" "}
                          Web Developer
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="img-gallery-container md:flex gap-10">
                    <div data-num="2" className="relative md:w-3/6">
                      <div className="relative flex justify-center">
                        <img
                          src="/Img/temple/dog.webp"
                          alt=""
                          className="img-gal md:h-[555px] h-[450px] w-10/12 md:w-11/12"
                        />
                        <div className="float-gallery-content absolute w-9/12 md:w-10/12 z-0 bg-[#fff] p-0 bottom-0 rounded-md flex justify-between opacity-0 hover:opacity-[1]">
                          <div className="content uk-text-left">
                            <span className="highlight uk-block p-3">
                              <div className="px-5">
                                <p>
                                  <strong>Marketing</strong>
                                </p>
                                Promote the company's products and services,
                                manage advertising campaigns on online
                                platforms, advise and support customers during
                                the shopping process.
                              </div>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="absolute z-[2] flex justify-center w-full top-0 h-full items-center">
                        <div className="position-main bg-[#fff] px-10 py-5 rounded-2xl opacity-50">
                          {" "}
                          Marketing
                        </div>
                      </div>
                    </div>

                    <div data-num="3" className="relative pt-10 md:w-3/6">
                      <div className="relative flex justify-center">
                        <img
                          src="/Img/temple/cat-t.jpg"
                          alt=""
                          className="img-gal md:h-[555px] h-[450px] w-10/12 md:w-11/12"
                        />
                        <div className="float-gallery-content absolute w-9/12 md:w-10/12 z-0 bg-[#fff] p-0 bottom-0 rounded-md flex justify-between opacity-0 hover:opacity-[1]">
                          <div className="content uk-text-left">
                            <span className="highlight uk-block p-3">
                              <div className="px-5">
                                <p>
                                  <strong>Product Manager</strong>
                                </p>
                                Ensure all projects and operating processes run
                                smoothly, on schedule and with quality.
                                Coordinate work between departments and resolve
                                arising problems.
                              </div>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="absolute z-[2] flex justify-center w-full top-0 h-full items-center">
                        <div className="position-main bg-[#fff] px-10 py-5 rounded-2xl opacity-50">
                          {" "}
                          Product Manager
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Section>

      <OurActivities/>

      {/* Contacts */}
      <Contact></Contact>
      <Fotter></Fotter>

      {/* <div className="fixednav">
        <Link className="ct-link" to="/">
          <div><FontAwesomeIcon icon={faHomeLgAlt} /></div>
          <div>Home</div>
        </Link>
        <Link className="ct-link" to="/abouts/">
          <div><FontAwesomeIcon icon={faAddressCard} /></div>
          <div>Abouts Us</div>
        </Link>
        <Link className="ct-link" to="/product/">
          <div><FontAwesomeIcon icon={faProjectDiagram} /></div>
          <div>Products</div>
        </Link>
        <Link className="ct-link" to="/contacts/">
          <div><FontAwesomeIcon icon={faInfo} /></div>
          <div>Contacts</div>
        </Link>
      </div> */}
      <FixedNav />
      <BlurryCursor isActive={isActive} />

      <div className="scrollElement">
        <div className="loading-page">
          <svg id="logo_svg" width="238" height="335" version="1.1" viewBox="0 0 1600 1600"
            xmlns="http://www.w3.org/2000/svg">
            <path transform="translate(1389,289)"
              d="m0 0c0.99 0.33 1.98 0.66 3 1 0.0934 28.5 0.164 57.1 0.207 85.6 0.0206 13.3 0.0487 26.5 0.0945 39.8 0.0399 11.6 0.0657 23.1 0.0746 34.7 0.00521 6.12 0.0175 12.2 0.0466 18.4 0.0272 5.76 0.0355 11.5 0.0295 17.3 0.0011 2.11 0.00905 4.22 0.0244 6.34 0.0199 2.89 0.0151 5.77 0.0042 8.66 0.0175 1.25 0.0175 1.25 0.0353 2.52-0.0743 7.3-2.67 13-7.36 18.6-0.517 0.624-1.03 1.25-1.57 1.89-0.544 0.642-1.09 1.28-1.65 1.94-1.17 1.4-2.33 2.81-3.5 4.21-0.58 0.697-1.16 1.39-1.76 2.11-2.49 3.03-4.9 6.13-7.31 9.23-3.96 5.09-8.06 10-12.3 14.9-3.74 4.39-7.31 8.9-10.9 13.5-5.11 6.55-10.4 13-15.6 19.4-2.72 3.34-5.44 6.69-8.16 10-1.08 1.33-2.17 2.67-3.25 4-0.536 0.66-1.07 1.32-1.62 2-17.9 22-17.9 22-19.5 24-1.08 1.33-2.16 2.66-3.25 4-2.73 3.36-5.46 6.72-8.2 10.1-5.16 6.33-10.3 12.7-15.3 19.1-3.96 5.08-8.06 10-12.3 14.9-3.31 3.89-6.49 7.86-9.62 11.9-3.57 4.59-7.22 9.08-11 13.5-4.21 4.92-8.25 9.94-12.2 15.1-7.79 9.99-15.9 19.7-23.9 29.6-7.53 9.21-15 18.4-22.3 27.8-3.06 3.9-6.23 7.69-9.46 11.4-4.18 4.87-8.14 9.88-12 15-0.496 0.654-0.992 1.31-1.5 1.98-0.708 0.949-0.708 0.949-1.43 1.92-0.412 0.551-0.824 1.1-1.25 1.67-1.25 1.86-2.36 3.74-3.47 5.69-0.632 1.11-1.26 2.23-1.91 3.37 1.85-0.00277 1.85-0.00277 3.74-0.00559 29.3-0.0433 58.6-0.0763 87.8-0.0965 3.6-0.0025 7.2-0.00509 10.8-0.00773 1.08-7.87e-4 1.08-7.87e-4 2.17-0.00159 11.6-0.00871 23.2-0.0245 34.9-0.0429 11.9-0.0187 23.8-0.0298 35.7-0.0339 6.7-0.0025 13.4-0.00853 20.1-0.0233 6.3-0.0135 12.6-0.0178 18.9-0.0148 2.32-5.52e-4 4.63-0.00456 6.95-0.0122 3.15-0.00989 6.3-0.00758 9.46-0.0021 1.39-0.00874 1.39-0.00874 2.8-0.0177 0.842 0.00398 1.68 0.00796 2.55 0.0121 0.728-7.59e-4 1.46-0.00152 2.21-0.0023 1.91 0.248 1.91 0.248 4.91 2.25 0.377 3 0.377 3 0.38 6.95 0.00466 0.727 0.00932 1.45 0.0141 2.2 0.012 2.46 0.00252 4.92-0.00676 7.39 0.00417 1.77 0.00964 3.55 0.0163 5.32 0.0145 4.89 0.0102 9.78 0.00283 14.7-0.00471 5.27 0.00776 10.5 0.018 15.8 0.0172 10.3 0.018 20.7 0.0128 31-0.00403 8.39-0.00261 16.8 0.00275 25.2 7.48e-4 1.19 0.0015 2.38 0.00227 3.61 0.00153 2.42 0.00307 4.84 0.00461 7.27 0.0137 22.7 0.00827 45.5-0.00319 68.2-0.00993 20.8 0.00301 41.6 0.0269 62.5 0.0244 21.4 0.034 42.7 0.0273 64.1-0.0035 12-0.00121 24 0.0163 36 0.0147 10.2 0.0154 20.4-0.00207 30.6-0.00855 5.22-0.0106 10.4 0.00465 15.6 0.0137 4.77 0.00922 9.54-0.0102 14.3-0.00379 1.73-7.43e-4 3.46 0.00961 5.19 0.013 2.34 0.00172 4.68-0.016 7.02-1.07e-4 1.3-2.15e-4 2.61-3.25e-4 3.95-0.5 3.13-0.5 3.13-2.19 4.8-2.83 1.62-4.59 1.7-7.84 1.7-1.13 0.00674-2.27 0.0135-3.44 0.0204-1.25-0.00788-2.5-0.0158-3.78-0.0239-1.34 0.00222-2.69 0.00575-4.03 0.0105-3.71 0.00923-7.42-3.41e-4 -11.1-0.0128-4.03-0.0103-8.06-0.00319-12.1 0.00173-7.07 0.00623-14.1 0.00127-21.2-0.0109-10.5-0.0181-21-0.019-31.5-0.0164-17.7 0.00395-35.4-0.0061-53-0.0241-17.5-0.0177-35-0.0293-52.5-0.0326-1.63-3.09e-4 -1.63-3.09e-4 -3.3-6.25e-4 -5.53-0.00101-11.1-0.00192-16.6-0.00278-39.2-0.00631-78.3-0.0265-117-0.0549-38-0.0275-76.1-0.0488-114-0.0615-1.17-3.95e-4 -2.34-7.89e-4 -3.55-0.0012-11.8-0.00396-23.5-0.00778-35.3-0.0115-24-0.00761-48-0.0161-71.9-0.0251-1.1-4.12e-4 -2.21-8.24e-4 -3.34-0.00125-73.7-0.0276-147-0.0751-221-0.126 0.956-1.28 1.91-2.56 2.87-3.84 0.533-0.712 1.07-1.42 1.61-2.16 1.8-2.38 3.67-4.7 5.58-7.01 2.69-3.26 5.36-6.52 8.02-9.8 5.18-6.41 10.4-12.8 15.7-19.1 3.74-4.39 7.39-8.83 11-13.3 7.26-9.11 14.6-18.1 22.2-27 3.26-3.83 6.38-7.76 9.46-11.7 4.25-5.48 8.68-10.8 13.2-16 5.39-6.23 10.6-12.6 15.7-19 0.782-0.975 1.56-1.95 2.37-2.95 0.696-0.875 1.39-1.75 2.11-2.65 3.03-3.42 5.78-5.96 10.1-7.41 2.26-0.104 4.52-0.147 6.78-0.158 1.05-0.00741 1.05-0.00741 2.12-0.015 2.36-0.0154 4.73-0.0238 7.09-0.0321 1.71-0.0096 3.42-0.0196 5.13-0.03 4.74-0.0274 9.48-0.0483 14.2-0.068 4.11-0.0177 8.22-0.0389 12.3-0.0599 12.5-0.0641 25.1-0.118 37.6-0.169 6.02-0.0247 12-0.0511 18.1-0.078 85.4-0.382 171-0.466 322-0.441 0.748 2.51e-4 1.5 5.03e-4 2.27 7.61e-4 30.8 0.0104 61.6 0.0314 92.5 0.0503v-154h-394c0-5.07 2.08-6.83 5.31-10.4 1.11-1.25 2.22-2.51 3.33-3.77 0.564-0.64 1.13-1.28 1.71-1.94 2.51-2.91 4.86-5.94 7.21-8.98 3.54-4.57 7.17-9.04 10.9-13.4 3.96-4.63 7.8-9.33 11.6-14.1 0.465-0.592 0.931-1.18 1.41-1.79 1.94-2.48 3.78-4.96 5.53-7.58h2c0.251-0.562 0.503-1.12 0.762-1.7 1.43-2.65 3.12-4.74 5.05-7.05l2.44-2.94c0.441-0.53 0.882-1.06 1.34-1.61 2.58-3.11 5.12-6.25 7.66-9.39 1.12-1.38 2.23-2.75 3.35-4.12 2.25-2.77 4.49-5.54 6.73-8.31 5.03-6.22 10.1-12.4 15.3-18.5 4.15-4.86 8.12-9.83 12-14.9 5.37-6.88 10.9-13.6 16.5-20.3 3.05-3.69 6.09-7.38 9.13-11.1l1.79-2.17c4.65-5.64 9.28-11.3 13.9-17 0.483-0.591 0.966-1.18 1.46-1.79 5.85-7.16 11.7-14.3 17.3-21.6 3.61-4.64 7.36-9.09 11.3-13.4 2.63-2.97 5.08-6.07 7.55-9.18 2.9-3.64 5.83-7.26 8.77-10.9 0.565-0.696 1.13-1.39 1.71-2.11 3.82-4.7 7.65-9.39 11.5-14.1 2.31-2.82 4.6-5.65 6.9-8.48 6.93-8.55 13.9-17 20.9-25.5 7.89-9.58 15.7-19.2 23.5-28.9 10.2-12.6 20.5-25.2 30.8-37.7 6.92-8.4 13.8-16.8 20.7-25.3 6.23-7.68 12.5-15.3 18.8-23 5.53-6.68 11-13.4 16.3-20.2 4.21-5.42 8.61-10.7 13.1-15.8 3.46-4 6.81-8.08 10.1-12.2 2.76-3.47 5.56-6.92 8.36-10.4 0.556-0.684 1.11-1.37 1.69-2.07 1.14-1.4 2.28-2.81 3.43-4.21 1.65-2.03 3.29-4.05 4.94-6.08 6.82-8.4 13.7-16.8 20.6-25.1 6.84-8.29 13.6-16.6 20.4-25 4.59-5.65 9.19-11.3 13.8-16.9 0.679-0.831 1.36-1.66 2.06-2.52 3.44-4.21 6.88-8.41 10.3-12.6 5.52-6.69 11-13.4 16.4-20.2 2.96-3.68 5.98-7.31 8.99-11 4.36-5.28 8.67-10.6 12.9-16 4.01-5.16 8.16-10.2 12.4-15.1 2.7-3.16 5.33-6.36 7.91-9.61 3.03-3.82 6.15-7.55 9.31-11.2 4.92-5.76 9.63-11.7 14.3-17.7 2.12-2.72 4.25-5.41 6.41-8.09z"
              fill="#000100" />
            <path transform="translate(814 65.8)"
              d="m0 0c0.772-0.00171 1.54-0.00342 2.34-0.00518 2.58-0.00329 5.17 0.0077 7.75 0.0186 1.85 5.64e-4 3.71 2.47e-4 5.56-8.85e-4 5.03-5.74e-4 10.1 0.0112 15.1 0.0251 5.26 0.0125 10.5 0.0137 15.8 0.0161 9.95 0.00622 19.9 0.0226 29.9 0.0427 11.3 0.0224 22.7 0.0334 34 0.0434 23.3 0.0209 46.6 0.0561 69.9 0.101 0.611 1.85 0.611 1.85 1 4-1.77 2.41-1.77 2.41-4.38 5.06-0.94 0.982-1.88 1.97-2.81 2.95-0.476 0.498-0.951 0.996-1.44 1.51-2.02 2.18-3.88 4.47-5.75 6.79-3.47 4.3-7.02 8.51-10.6 12.7-3.54 4.1-7.03 8.23-10.4 12.4-4.14 5.1-8.44 10.1-12.8 15-3.92 4.51-7.73 9.1-11.5 13.7-2.72 3.31-5.51 6.56-8.31 9.81-3.55 4.12-7.07 8.27-10.5 12.5-4.39 5.4-8.92 10.7-13.5 16-4.26 4.95-8.46 9.94-12.7 14.9-1.39 1.65-2.79 3.29-4.18 4.93-4.23 4.98-8.44 9.98-12.6 15.1-4.17 5.12-8.49 10.1-12.8 15.1-3.92 4.51-7.73 9.1-11.5 13.7-3.68 4.48-7.48 8.86-11.3 13.3-4.26 4.95-8.46 9.94-12.7 14.9-1.39 1.65-2.79 3.29-4.18 4.93-4.25 5.01-8.48 10-12.6 15.1-4.41 5.42-8.96 10.7-13.5 16-6.25 7.26-12.4 14.6-18.5 22-4.41 5.42-8.96 10.7-13.5 16-6.23 7.24-12.4 14.5-18.4 21.9-3.52 4.33-7.14 8.55-10.8 12.8-5.33 6.11-10.5 12.3-15.6 18.6-4.26 5.2-8.6 10.3-13 15.4-2.93 3.4-5.8 6.84-8.62 10.3-4.1 5.05-8.35 9.96-12.6 14.9-6.89 7.92-13.7 15.9-20.3 24.1-4.17 5.12-8.49 10.1-12.8 15.1-3.92 4.51-7.73 9.1-11.5 13.7-2.72 3.31-5.51 6.56-8.31 9.81-3.55 4.12-7.07 8.27-10.5 12.5-4.39 5.4-8.91 10.7-13.4 15.9-6.25 7.26-12.4 14.6-18.5 22-4.41 5.42-8.96 10.7-13.5 16-6.23 7.24-12.4 14.5-18.4 21.9-4.17 5.12-8.49 10.1-12.8 15.1-3.92 4.51-7.73 9.1-11.5 13.7-3.68 4.48-7.48 8.86-11.3 13.3-4.26 4.95-8.46 9.94-12.7 14.9-1.39 1.65-2.79 3.29-4.18 4.93-4.25 5.01-8.48 10-12.6 15.1-4.41 5.42-8.96 10.7-13.5 16-4.26 4.95-8.46 9.94-12.7 14.9-1.39 1.65-2.79 3.29-4.18 4.93-4.25 5.01-8.48 10-12.6 15.1-4.41 5.42-8.96 10.7-13.5 16-6.25 7.26-12.4 14.6-18.5 22-4.42 5.42-8.96 10.7-13.5 16-3.32 3.86-6.61 7.75-9.89 11.6-2.91 3.44-5.84 6.87-8.78 10.3-4.52 5.25-8.95 10.6-13.2 16-3.13 3.87-6.38 7.62-9.63 11.4-3.03 3.52-6.01 7.07-8.93 10.7-4.1 5.05-8.35 9.96-12.6 14.9-6.89 7.92-13.7 15.9-20.3 24.1-4.17 5.12-8.49 10.1-12.8 15.1-3.92 4.51-7.73 9.1-11.5 13.7-2.72 3.31-5.51 6.56-8.31 9.81-3.55 4.12-7.07 8.27-10.5 12.5-4.39 5.4-8.91 10.7-13.4 15.9-6.25 7.26-12.4 14.6-18.5 22-3.91 4.81-7.93 9.52-12 14.2-3.49 4.06-6.96 8.13-10.4 12.2-4.01 4.75-8.06 9.47-12.2 14.1-0.66-0.33-1.32-0.66-2-1-0.112-88.7-0.224-177-0.328-266-0.00155-1.31-0.0031-2.62-0.00469-3.98-0.0328-27.8-0.0654-55.6-0.0978-83.5-0.0163-14-0.0326-28-0.0489-41.9-0.00246-2.11-0.00493-4.22-0.00739-6.32-0.0379-32.5-0.0767-65-0.118-97.4-8.87e-4 -0.699-0.00177-1.4-0.00269-2.12-0.0143-11.3-0.0287-22.5-0.0431-33.8-0.0414-32.4-0.0824-64.9-0.12-97.3-7.69e-4 -0.666-0.00154-1.33-0.00233-2.02-0.0161-14-0.032-27.9-0.0476-41.9-0.00732-6.54-0.0147-13.1-0.022-19.6-0.00145-1.29-0.0029-2.58-0.0044-3.9-0.0235-20.8-0.0505-41.5-0.0787-62.3-0.0283-20.9-0.053-41.7-0.0739-62.6-0.0126-12.4-0.028-24.8-0.0473-37.2-0.0126-8.27-0.0217-16.5-0.0277-24.8-0.00355-4.72-0.00874-9.45-0.0183-14.2-0.00862-4.29-0.0127-8.58-0.0131-12.9-9.44e-4 -1.55-0.00361-3.1-0.0081-4.65-0.00581-2.09-0.00557-4.18-0.00369-6.27-0.0014-1.16-0.00281-2.32-0.00425-3.52 0.122-2.57 0.122-2.57 1.12-3.57h150v525c4.95-4.33 9.56-8.43 13.9-13.2 0.512-0.56 1.02-1.12 1.55-1.7 3.9-4.29 7.6-8.72 11.2-13.2 2.55-3.14 5.15-6.23 7.78-9.31 3.35-3.95 6.67-7.92 9.94-11.9 3.96-4.86 8.03-9.62 12.1-14.4 3.03-3.52 6.01-7.08 8.94-10.7 3.93-4.85 7.98-9.58 12.1-14.3 3.03-3.52 6.01-7.08 8.94-10.7 3.33-4.1 6.74-8.13 10.2-12.1 4.51-5.23 8.93-10.5 13.3-15.9 4.86-5.94 9.8-11.8 14.8-17.6 3.71-4.31 7.33-8.69 10.9-13.1 2.56-3.12 5.16-6.2 7.78-9.28 4.11-4.84 8.15-9.73 12.2-14.7 3.22-3.91 6.5-7.77 9.8-11.6 2.54-2.94 2.54-2.94 4.54-6.24h2c0.22-0.53 0.441-1.06 0.668-1.61 1.81-3.25 4.21-5.92 6.64-8.71 3.08-3.57 6.09-7.1 8.75-11 0.639-0.887 1.28-1.77 1.94-2.69h2c0.224-0.534 0.449-1.07 0.68-1.62 1.76-3.18 4.07-5.78 6.45-8.51 1-1.17 2.01-2.34 3.01-3.51 0.492-0.574 0.983-1.15 1.49-1.74 1.82-2.15 3.57-4.35 5.31-6.56 3.75-4.74 7.69-9.31 11.6-13.9 3.56-4.13 6.99-8.34 10.4-12.6 2.91-3.61 5.91-7.14 8.92-10.7 2.92-3.43 5.79-6.89 8.64-10.4 3.75-4.61 7.57-9.14 11.4-13.7 2.88-3.39 5.72-6.82 8.52-10.3 3.96-4.86 8.03-9.62 12.1-14.4 3.03-3.52 6.01-7.08 8.94-10.7 3.43-4.23 6.95-8.38 10.5-12.5 4.32-5.02 8.55-10.1 12.7-15.2 4.82-5.88 9.76-11.6 14.7-17.4 4.72-5.55 9.42-11.1 14-16.8 3.96-4.86 8.03-9.62 12.1-14.4 3.8-4.42 7.5-8.9 11.2-13.4 4.82-5.88 9.77-11.7 14.7-17.5 6.85-8.05 6.85-8.05 13.5-16.3 3.75-4.74 7.69-9.31 11.6-13.9 2.88-3.34 5.69-6.71 8.42-10.2 3.72-4.72 7.63-9.26 11.6-13.8 3.03-3.52 5.96-7.09 8.81-10.8 6.35-8.01 11.9-11.8 22.4-11.7z"
              fill="#000100" />
            <path transform="translate(1213 65.9)"
              d="m0 0c0.712-0.00156 1.42-0.00312 2.16-0.00473 2.39-0.00399 4.77-8.28e-4 7.16 0.00232 1.71-0.00136 3.42-0.00314 5.14-0.00531 4.65-0.00456 9.3-0.00279 14 3.79e-4 4.87 0.00253 9.74 1.84e-4 14.6-0.00139 8.18-0.00182 16.4 5.8e-4 24.5 0.00534 9.45 0.00544 18.9 0.00368 28.3-0.00183 8.12-0.00454 16.2-0.00518 24.3-0.00256 4.85 0.00156 9.69 0.00177 14.5-0.00154 4.56-0.0029 9.12-8.7e-4 13.7 0.00489 1.67 0.00132 3.34 9.5e-4 5.01-0.00126 2.29-0.00275 4.57 7.15e-4 6.86 0.00568 1.28 3.77e-4 2.56 7.54e-4 3.87 0.00114 3.97 0.135 7.77 0.577 11.7 1.13-1.32 3.73-2.92 6.45-5.44 9.5-1.07 1.31-1.07 1.31-2.16 2.64-3.98 4.75-7.97 9.48-12 14.2-1.39 1.63-2.77 3.26-4.15 4.9-4.77 5.66-9.57 11.3-14.4 16.9-3.49 4.06-6.94 8.15-10.3 12.3-4.1 5.05-8.35 9.96-12.6 14.9-6.91 7.95-13.7 16-20.4 24.1-3.96 4.86-8.03 9.62-12.1 14.4-3.8 4.42-7.51 8.91-11.2 13.4-2.45 2.99-4.94 5.94-7.45 8.88-4.3 5.06-8.54 10.2-12.8 15.3-4.91 5.98-9.89 11.9-14.9 17.7-3.45 4.01-6.78 8.11-10.1 12.3-2.91 3.61-5.91 7.14-8.92 10.7-2.92 3.43-5.79 6.89-8.64 10.4-3.75 4.61-7.57 9.14-11.4 13.7-2.88 3.39-5.72 6.82-8.52 10.3-3.47 4.27-7.03 8.46-10.6 12.6-3.39 3.93-6.72 7.87-9.94 11.9-3.71 4.7-7.6 9.23-11.5 13.8-3.05 3.54-6.05 7.11-8.99 10.7-3.93 4.85-7.98 9.58-12.1 14.3-3.03 3.52-6.01 7.08-8.94 10.7-3.93 4.85-7.98 9.58-12.1 14.3-3.03 3.52-6.01 7.08-8.94 10.7-3.43 4.23-6.95 8.38-10.5 12.5-4.32 5.01-8.55 10.1-12.7 15.2-3.02 3.68-6.11 7.31-9.19 10.9-2.88 3.39-5.72 6.82-8.52 10.3-3.96 4.86-8.03 9.62-12.1 14.4-3.03 3.52-6.01 7.08-8.94 10.7-3.43 4.23-6.95 8.38-10.5 12.5-4.32 5.01-8.55 10.1-12.7 15.2-2.56 3.12-5.16 6.2-7.78 9.28-3.37 3.97-6.71 7.96-10 12-3.75 4.6-7.57 9.14-11.4 13.7-2.9 3.42-5.76 6.86-8.59 10.3-3.75 4.6-7.57 9.14-11.4 13.7-2.9 3.42-5.76 6.86-8.59 10.3-3.29 4.04-6.63 8.03-10 12-4.05 4.77-8.04 9.58-12 14.4-3.12 3.82-6.25 7.64-9.38 11.4-0.602 0.732-1.2 1.46-1.82 2.22-3.62 4.4-7.29 8.76-11 13.1-4.26 4.99-8.31 10.1-12.3 15.3-3.37 4.31-6.96 8.36-10.7 12.4-3.27 3.71-6.27 7.61-9.3 11.5-3.21 4.12-6.56 8.05-10.1 11.9-2.94 3.3-5.69 6.75-8.47 10.2-2.73 3.32-5.54 6.57-8.35 9.82-4.06 4.69-7.96 9.47-11.8 14.4-4.11 5.32-8.48 10.3-13.1 15.2-2.87 3.17-5.49 6.48-8.13 9.84-2.64 3.28-5.38 6.47-8.13 9.66-4.34 5.04-8.6 10.1-12.8 15.3-4.82 5.88-9.76 11.6-14.7 17.4-4.72 5.55-9.42 11.1-14 16.8-3.96 4.86-8.03 9.62-12.1 14.4-3.8 4.41-7.5 8.9-11.2 13.4-2.56 3.12-5.16 6.2-7.78 9.28-3.37 3.97-6.71 7.96-10 12-3.75 4.6-7.57 9.14-11.4 13.7-3.64 4.3-7.21 8.65-10.8 13-2.59 3.15-5.23 6.27-7.88 9.38-3.19 3.75-6.33 7.52-9.38 11.4-3.75 4.74-7.69 9.31-11.6 13.9-3.56 4.13-6.99 8.34-10.4 12.6-2.91 3.61-5.91 7.14-8.92 10.7-2.92 3.43-5.79 6.89-8.64 10.4-3.75 4.6-7.57 9.14-11.4 13.7-2.9 3.42-5.76 6.86-8.59 10.3-3.75 4.61-7.57 9.14-11.4 13.7-2.88 3.39-5.72 6.82-8.52 10.3-3.96 4.86-8.03 9.62-12.1 14.4-3.8 4.41-7.5 8.9-11.2 13.4-3.02 3.69-6.11 7.31-9.2 10.9-2.86 3.37-5.67 6.77-8.46 10.2-4.17 5.12-8.49 10.1-12.8 15.1-3.16 3.63-6.27 7.3-9.3 11-3.58 4.42-7.27 8.72-11 13-4.5 5.17-8.91 10.4-13.2 15.7-3.19 3.89-6.45 7.72-9.73 11.5-2.54 2.94-2.54 2.94-4.54 6.24h-2c-0.226 0.535-0.451 1.07-0.684 1.62-1.74 3.15-4.03 5.74-6.38 8.44-1 1.17-2 2.34-3 3.5-0.498 0.58-0.995 1.16-1.51 1.76-2.01 2.36-3.97 4.77-5.93 7.18-3.75 4.6-7.57 9.14-11.4 13.7-3.64 4.3-7.21 8.65-10.8 13-2.59 3.15-5.23 6.27-7.88 9.38-3.87 4.55-7.64 9.17-11.4 13.9-2.41 2.99-4.9 5.91-7.39 8.83-3.8 4.46-7.48 8.99-11.1 13.6-4.4 5.68-9.04 11.1-13.8 16.5-3.68 4.21-7.18 8.51-10.6 12.9-3.89 5.03-7.94 9.83-12.3 14.5-1.79 1.98-3.41 4.02-5.05 6.12-3.95 4.59-8.9 5.87-14.8 6.43-1.36 0.0124-2.73 0.00882-4.09-0.00838-0.758 0.00256-1.52 0.00513-2.3 0.00777-2.52 0.00491-5.04-0.0115-7.55-0.028-1.81-8.47e-4 -3.63-3.7e-4 -5.44 0.00133-4.91 8.59e-4 -9.82-0.0167-14.7-0.0377-5.14-0.0188-10.3-0.0205-15.4-0.0241-9.72-0.00931-19.4-0.0339-29.2-0.064-11.1-0.0336-22.1-0.05-33.2-0.0651-22.8-0.0313-45.5-0.0841-68.3-0.151 0.439-1.43 0.889-2.86 1.34-4.28 0.374-1.19 0.374-1.19 0.755-2.41 1.43-3.65 3.76-6.22 6.4-9.06 1.08-1.21 2.16-2.42 3.24-3.63 0.817-0.903 0.817-0.903 1.65-1.82 2.49-2.78 4.9-5.63 7.3-8.48 0.455-0.538 0.91-1.08 1.38-1.63 2.83-3.35 5.61-6.72 8.37-10.1 3.96-4.86 8.03-9.62 12.1-14.4 3.8-4.41 7.5-8.9 11.2-13.4 2.56-3.12 5.16-6.2 7.78-9.28 3.37-3.97 6.71-7.96 10-12 3.75-4.61 7.57-9.14 11.4-13.7 2.88-3.39 5.72-6.82 8.52-10.3 4.41-5.42 8.96-10.7 13.5-16 6.25-7.26 12.4-14.6 18.5-22 3.96-4.86 8.03-9.62 12.1-14.4 3.03-3.52 6.01-7.08 8.94-10.7 3.93-4.85 7.98-9.58 12.1-14.3 3.03-3.52 6.01-7.08 8.94-10.7 3.93-4.85 7.98-9.58 12.1-14.3 3.03-3.52 6.01-7.08 8.94-10.7 3.93-4.85 7.98-9.58 12.1-14.3 3.03-3.52 6.01-7.08 8.94-10.7 4.39-5.4 8.91-10.7 13.4-15.9 6.25-7.26 12.4-14.6 18.5-22 3.96-4.86 8.03-9.62 12.1-14.4 3.03-3.52 6.01-7.08 8.94-10.7 3.43-4.23 6.95-8.38 10.5-12.5 4.33-5.02 8.56-10.1 12.7-15.2 2.45-2.99 4.94-5.94 7.45-8.88 4.32-5.08 8.58-10.2 12.8-15.4 4.68-5.7 9.39-11.4 14.2-17 3.56-4.19 7.05-8.45 10.5-12.7 3.04-3.69 6.13-7.33 9.23-11 3.65-4.3 7.22-8.66 10.8-13 2.53-3.07 5.1-6.09 7.68-9.11 3.87-4.54 7.6-9.16 11.2-13.9 3.89-5.02 7.96-9.78 12.3-14.5 2.84-3.16 5.46-6.47 8.09-9.8 5.82-7.37 11.9-14.6 17.9-21.7 2.88-3.39 5.72-6.82 8.52-10.3 3.47-4.27 7.03-8.46 10.6-12.6 3.39-3.93 6.72-7.87 9.94-11.9 3.71-4.7 7.6-9.23 11.5-13.8 3.05-3.54 6.05-7.11 8.99-10.7 3.93-4.85 7.98-9.58 12.1-14.3 3.03-3.52 6.01-7.08 8.94-10.7 4.39-5.4 8.91-10.7 13.4-15.9 14.7-17.1 14.7-17.1 28.6-35 0.698-0.783 0.698-0.783 1.41-1.58h2c0.226-0.535 0.451-1.07 0.684-1.62 1.74-3.15 4.03-5.74 6.38-8.44 1-1.17 2.01-2.34 3.01-3.51 0.498-0.58 0.996-1.16 1.51-1.76 1.99-2.34 3.93-4.72 5.86-7.11 3.96-4.86 8.03-9.62 12.1-14.4 3.8-4.41 7.5-8.9 11.2-13.4 2.56-3.12 5.16-6.2 7.78-9.28 3.37-3.97 6.71-7.96 10-12 3.75-4.6 7.57-9.14 11.4-13.7 2.9-3.42 5.76-6.86 8.59-10.3 3.75-4.6 7.57-9.14 11.4-13.7 2.9-3.42 5.76-6.86 8.59-10.3 3.75-4.6 7.57-9.14 11.4-13.7 2.9-3.42 5.76-6.86 8.59-10.3 3.75-4.6 7.57-9.14 11.4-13.7 2.9-3.42 5.76-6.86 8.59-10.3 3.75-4.6 7.57-9.14 11.4-13.7 2.9-3.42 5.76-6.86 8.59-10.3 3.75-4.6 7.57-9.14 11.4-13.7 2.9-3.42 5.76-6.86 8.59-10.3 5.54-6.8 11.2-13.5 16.9-20.2 5.49-6.46 10.9-12.9 16.3-19.5 3.04-3.69 6.13-7.33 9.23-11 2.9-3.42 5.76-6.86 8.59-10.3 3.75-4.6 7.57-9.14 11.4-13.7 2.9-3.42 5.76-6.86 8.59-10.3 3.75-4.6 7.57-9.14 11.4-13.7 2.9-3.42 5.76-6.86 8.59-10.3 3.75-4.61 7.57-9.14 11.4-13.7 2.88-3.39 5.72-6.82 8.52-10.3 3.96-4.86 8.03-9.62 12.1-14.4 3.8-4.41 7.5-8.9 11.2-13.4 2.56-3.12 5.16-6.2 7.78-9.28 4.05-4.77 8.05-9.58 12-14.4 8.02-9.84 16.1-19.6 24.4-29.2 3.45-4.01 6.78-8.11 10.1-12.3 2.91-3.61 5.91-7.14 8.92-10.7 2.9-3.41 5.75-6.85 8.57-10.3 3.47-4.27 7.03-8.46 10.6-12.6 3.39-3.93 6.72-7.87 9.94-11.9 3.71-4.7 7.6-9.22 11.5-13.8 3.81-4.43 7.53-8.93 11.2-13.5 2.56-3.12 5.16-6.2 7.78-9.28 3.39-3.99 6.75-8 10.1-12.1 0.722-0.879 1.44-1.76 2.19-2.66 1.61-1.98 3.19-3.97 4.75-5.98 7.66-9.72 14.1-13.9 26.6-13.9z"
              fill="#000100" />
          </svg>
          <div className="name-container">
            <div className="logo-name">VIS GROUP</div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default Home;

// // Test ở phần này
// const getPageHeight = () => {
//   const body = document.body;
//   const html = document.documentElement;
//   console.log( "content heights ",content.current.scrollHeight);
//   return Math.max(
//     body.scrollHeight, body.offsetHeight,
//     html.clientHeight, html.scrollHeight, html.offsetHeight
//   );
// };

// // Code cập nhật chiều cao trang
// const adjustBodyHeight = () => {
//   const contentHeight = content.current.scrollHeight;
//   document.body.style.height = `${contentHeight} px`;
//   console.log("Adjusted body height to: ", contentHeight);
// };

// useEffect(() => {
//   adjustBodyHeight();
//   // Cập nhật chiều cao khi cửa sổ được resize hoặc nội dung thay đổi
//   window.addEventListener('resize', adjustBodyHeight);
//   return () => window.removeEventListener('resize', adjustBodyHeight);
// }, [content]); // Phụ thuộc vào nội dung để đảm bảo chiều cao luôn cập nhật
